import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DialogComponent } from 'src/app/components/core/components/dialog/dialog.component';

@Component({
    selector: 'app-empresadeshidratadora-detail-dialog',
    templateUrl: './empresadeshidratadora-detail-dialog.component.html',
    styleUrls: ['./empresadeshidratadora-detail-dialog.component.scss'],
})
export class EmpresadeshidratadoraDetailDialogComponent implements OnChanges {
    @Input() Id: number | null;
    @Input() visible = false;
    @Output() closed = new EventEmitter<any>();

    @ViewChild(DialogComponent) private dialogComponent: DialogComponent;

    dialogTitle = 'Detalle de la Empresa Deshidratadora';

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.visible?.currentValue !== null) {
            if (this.visible) {
                this.openDialog();
            }
        }
    }

    private openDialog(): void {
        // Doing this we avoid the inner component to be initiated in first place
        setTimeout(() => {
            // To give time so the dialog is initialized
            this.dialogComponent?.showDialog();
        });
    }

    /**
     * When the user selects "Aceptar" in the dialog, 'accepted' will be true
     * If the user clicks "Cancelar", 'accepted' will be false, in this case the preselection is discarded.
     * @param accepted boolean
     */
    onDialogAccepted(accepted: boolean): void {
        if (!accepted) {
            this.closed.emit();
        }
    }
}
